import { TablePagination as MuiTablePagination } from "@mui/material";
import MuiTableContainer from "@mui/material/TableContainer";
import React from "react";
import { PaginationActions } from "../../Pagination/PaginationActions";
export default function GridContainer(props) {
    const { children, style } = props;
    const { allowPagination, dataCount, gotoPage, page, rowCount, rowsPerPage, rowsPerPageOptions, setPageSize } = props.paginationProps;
    // #region Pagination handlers
    const handleChangePage = (event, newPage) => {
        gotoPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setPageSize(Number(event.target.value));
    };
    // #endregion
    return (React.createElement(MuiTableContainer, { style: { ...style, display: "flex", flexDirection: "column", overflow: "hidden", position: "relative" }, "data-testid": "grid-container" },
        children,
        allowPagination ? (React.createElement(MuiTablePagination, { rowsPerPageOptions: [...rowsPerPageOptions, { label: "All", value: Math.max(rowCount, dataCount) }], colSpan: 3, count: dataCount, rowsPerPage: rowsPerPage, page: page, SelectProps: {
                inputProps: { "aria-label": "rows per page" },
                native: true
            }, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage, 
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            ActionsComponent: PaginationActions, component: "div" })) : null));
}
